import { AwsClientOverrides } from '@localstack/services';
import { ComplexLayoutProps, UseFeatureFlagsReturnType, UseAuthProvider } from '@localstack/types';

import { ReactElement } from 'react';

import { RESOURCES_TYPES } from '../constants';

/**
 * Base interface for components whose layout need to be injected.
 * Routes such as Resource Browser ones and instance ones are shared
 * between desktop app and Console so we need to change the surrounding layout based
 * on where we are using them
 */
export interface InjectableViewProps<R extends Record<string, string>> {
  Layout: (props: ComplexLayoutProps) => JSX.Element;
  routes: R;
  clientOverrides?: AwsClientOverrides;
  useAuthProvider: UseAuthProvider;
  useFeatureFlags: () => UseFeatureFlagsReturnType;
  onFeatureUpgradeButtonClick: () => void;
  /**
   * Workspace flagged for commercial misuse of the Freemium Hobby plan. When true, views
   * that surface upgrade CTAs (e.g. AwsServiceTile's FeatureUnavailableDialog) should
   * skip Hobby as the suggested upgrade tier.
   */
  isFreemiumHobbyCommercialMisuse?: boolean;
}

export type PostOnClickProps = {
  serviceCode: keyof typeof RESOURCES_TYPES;
};

export interface ResourceBrowserProps<R extends Record<string, string>> extends InjectableViewProps<R> {
  postOnClick?: (props: PostOnClickProps) => unknown;
}

export interface InjectableViewsAdapterProps {
  Component: (props: InjectableViewProps<Record<string, string>>) => ReactElement;
  routes: Record<string, string>;
  endpoint?: string;
}
